<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import Lucide from '@/components/Base/Lucide';
import type { Icon } from '@/components/Base/Lucide/icon.types';
import { useMobile } from '@/composables/useMobile';

interface NavigationItem {
  name: string;
  icon: Icon;
  route: string;
  label: string;
}

const { isMobile } = useMobile();
const route = useRoute();
const router = useRouter();

const navigationItems: NavigationItem[] = [
  {
    name: 'Dashboard',
    icon: 'Home',
    route: '/',
    label: 'Home',
  },
  {
    name: 'Users',
    icon: 'Users',
    route: '/users',
    label: 'Users',
  },
];

const isActiveRoute = (routePath: string) => {
  return route.path === routePath || route.path.startsWith(routePath + '/');
};

const navigateTo = (routePath: string) => {
  router.push(routePath);
};
</script>

<template>
  <div v-if="isMobile" class="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-slate-200 shadow-lg">
    <div class="flex items-center justify-around py-2">
      <button
        v-for="item in navigationItems"
        :key="item.name"
        @click="navigateTo(item.route)"
        :class="[
          'flex flex-col items-center justify-center py-2 px-4 rounded-lg transition-all duration-200',
          'hover:bg-slate-50 active:scale-95',
          {
            'text-primary bg-primary/5': isActiveRoute(item.route),
            'text-slate-600': !isActiveRoute(item.route),
          },
        ]"
      >
        <Lucide
          :icon="item.icon"
          :class="[
            'w-5 h-5 mb-1 transition-colors',
            {
              'text-primary': isActiveRoute(item.route),
              'text-slate-600': !isActiveRoute(item.route),
            },
          ]"
        />
        <span
          :class="[
            'text-xs font-medium transition-colors',
            {
              'text-primary': isActiveRoute(item.route),
              'text-slate-600': !isActiveRoute(item.route),
            },
          ]"
        >
          {{ item.label }}
        </span>
      </button>
    </div>
  </div>
</template>
